// extracted by mini-css-extract-plugin
module.exports = {"section":"_1ziHk","teams":"_19Ak_","team":"_3Lbdd","teamsSeparator":"_3SRHs","teamName":"_3kMMw","teamHome":"_3ttq-","teamAway":"KX4hj","teamImg":"_1Yj4B","matchTime":"_3IsiK"};